import { useState, useEffect } from 'react';
import { useColoResource } from './useColoResource';
import { MerchantDetails } from 'olo-service';
import { isNotFoundError, isSlugNotFound } from 'util/axiosHelpers';
import { useSmartNavigate } from 'hooks/useSmartNavigate';

export function useGetMerchantDetailsResource(merchantId?: string) {
  const [id, setId] = useState(merchantId);
  const [isSlugCheck, setSlug] = useState(true);
  const [navPage, setNavPage] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useSmartNavigate();
  const [,merchantDetails, error] = useColoResource<MerchantDetails>(() => id &&({
    url: id,
    params: { slug: isSlugCheck },
  }), [id,isSlugCheck]);

  useEffect(() => {
    if (isSlugNotFound(error,merchantId) && (!merchantId?.includes('-') && merchantId?.length === 13 )){
      setSlug(false);
    } else if (isNotFoundError(error)){
      setNavPage(true);
      setLoading(false);
      navigate('~/not-found');
   }

    if (merchantId === merchantDetails?.slug || merchantId === merchantDetails?.merchantUuid) return;

    setId(merchantId);
  }, [merchantId, merchantDetails, error, isSlugCheck, id, navigate]);

  useEffect(()=>{
    if (merchantDetails){
      setLoading(false);
    }
  },[merchantDetails]);

  return { isLoading:loading, merchantDetails, error, isSlugCheck, navPage };
}
